import Router from "@/Router";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Toaster } from "react-hot-toast";
import ToggleSidebarContextProvider from "./lib/toggleSidebar/ToggleSidebarContextProvider";
import LogRocketIntegration from "./lib/LogRocketIntegration";
import CrispProvider from "./lib/crisp/CrispProvider";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: Infinity,
      retry: false,
    },
  },
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <LogRocketIntegration appId={import.meta.env.LOGROCKET_APP_ID} />
      <CrispProvider>
        <ToggleSidebarContextProvider>
          <Router />
        </ToggleSidebarContextProvider>
      </CrispProvider>
    </QueryClientProvider>
    <Toaster position="top-center" toastOptions={{ className: "break-all" }} />
  </StrictMode>,
);
